import bem from 'utils/bem';

export const block = bem('intro-outro-upsell-modal');
